/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Activation_IdInputs */

const en_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase ID for product activation`)
};

const id_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Pembelian untuk aktivasi produk`)
};

const ms_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID pembelian untuk pengaktifan produk`)
};

const ca_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de compra per a l'activació del producte`)
};

const cs_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID nákupu pro aktivaci produktu`)
};

const da_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Købs-ID til produktaktivering`)
};

const de_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kauf-ID zur Produktaktivierung`)
};

const et_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostu ID toote aktiveerimiseks`)
};

const es_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de compra para la activación del producto`)
};

const fr_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID d’achat pour l’activation du produit`)
};

const hr_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID kupnje za aktivaciju proizvoda`)
};

const it_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID di acquisto per l'attivazione del prodotto`)
};

const lv_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirkuma ID produkta aktivizēšanai`)
};

const lt_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirkimo ID produkto aktyvavimui`)
};

const hu_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vásárlási azonosító a termék aktiválásához`)
};

const nl_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aankoop-ID voor productactivering`)
};

const nb_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kjøps-ID for produktaktivering`)
};

const pl_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identyfikator zakupu do aktywacji produktu`)
};

const pt_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de compra para ativação do produto`)
};

const ro_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de achiziție pentru activarea produsului`)
};

const sk_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID nákupu pre aktiváciu produktu`)
};

const sl_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID nakupa za aktivacijo izdelka`)
};

const fi_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostotunnus tuotteen aktivointia varten`)
};

const sv_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Köp-ID för produktaktivering`)
};

const vi_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID mua hàng để kích hoạt sản phẩm`)
};

const tr_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürün etkinleştirme için satın alma kimliği`)
};

const el_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αναγνωριστικό αγοράς για ενεργοποίηση προϊόντος`)
};

const bg_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID на покупка за активиране на продукта`)
};

const ru_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор покупки для активации продукта`)
};

const sr_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID куповине за активацију производа`)
};

const uk_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ідентифікатор покупки для активації продукту`)
};

const ka_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`შეძენის ID პროდუქტის გასააქტიურებლად`)
};

const hi_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उत्पाद सक्रियण के लिए खरीद ID`)
};

const th_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รหัสการซื้อสำหรับการเปิดใช้งานผลิตภัณฑ์`)
};

const ko_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제품 활성화를 위한 구매 ID`)
};

const zh_tw_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用於產品啟用的購買 ID`)
};

const ja_product_activation_id = /** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`製品アクティベーション用購入 ID`)
};

/** @type {(inputs: Product_Activation_IdInputs) => LocalizedString} */
const zh_product_activation_id = en_product_activation_id;

/**
* | output |
* | --- |
* | "Purchase ID for product activation" |
*
* @param {Product_Activation_IdInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const product_activation_id = /** @type {((inputs?: Product_Activation_IdInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Activation_IdInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_product_activation_id(inputs)
	if (locale === "ms") return ms_product_activation_id(inputs)
	if (locale === "ca") return ca_product_activation_id(inputs)
	if (locale === "cs") return cs_product_activation_id(inputs)
	if (locale === "da") return da_product_activation_id(inputs)
	if (locale === "de") return de_product_activation_id(inputs)
	if (locale === "et") return et_product_activation_id(inputs)
	if (locale === "es") return es_product_activation_id(inputs)
	if (locale === "fr") return fr_product_activation_id(inputs)
	if (locale === "hr") return hr_product_activation_id(inputs)
	if (locale === "it") return it_product_activation_id(inputs)
	if (locale === "lv") return lv_product_activation_id(inputs)
	if (locale === "lt") return lt_product_activation_id(inputs)
	if (locale === "hu") return hu_product_activation_id(inputs)
	if (locale === "nl") return nl_product_activation_id(inputs)
	if (locale === "nb") return nb_product_activation_id(inputs)
	if (locale === "pl") return pl_product_activation_id(inputs)
	if (locale === "pt") return pt_product_activation_id(inputs)
	if (locale === "ro") return ro_product_activation_id(inputs)
	if (locale === "sk") return sk_product_activation_id(inputs)
	if (locale === "sl") return sl_product_activation_id(inputs)
	if (locale === "fi") return fi_product_activation_id(inputs)
	if (locale === "sv") return sv_product_activation_id(inputs)
	if (locale === "vi") return vi_product_activation_id(inputs)
	if (locale === "tr") return tr_product_activation_id(inputs)
	if (locale === "el") return el_product_activation_id(inputs)
	if (locale === "bg") return bg_product_activation_id(inputs)
	if (locale === "ru") return ru_product_activation_id(inputs)
	if (locale === "sr") return sr_product_activation_id(inputs)
	if (locale === "uk") return uk_product_activation_id(inputs)
	if (locale === "ka") return ka_product_activation_id(inputs)
	if (locale === "hi") return hi_product_activation_id(inputs)
	if (locale === "th") return th_product_activation_id(inputs)
	if (locale === "ko") return ko_product_activation_id(inputs)
	if (locale === "zh") return zh_product_activation_id(inputs)
	if (locale === "zh-tw") return zh_tw_product_activation_id(inputs)
	if (locale === "ja") return ja_product_activation_id(inputs)
	return en_product_activation_id(inputs)
});